<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).on('click', '.gbbGreetingCardImageList .greetingCardImageAndDetailsWrapper', function () {
  console.log('click');
  $('html, body').animate({
    'scrollTop': $(".gbbGiftMessageV2MainContent").position().top + 100
  });
});

$(document).on('click', '[data-wishlist]', (event) => {
  event.preventDefault();
  event.stopPropagation();

  if (!$('body').hasClass('suffix-template-wishlist')) {
    $('[data-wishlist-items-display]').removeClass('is-loaded');

    var $target = $(event.currentTarget),
      id = $target.data('product-id'),
      handle = $target.data('wishlist-handle'),
      wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
    index = wishlistList.indexOf(handle),
      wishlistContainer = $('[data-wishlist-container]');

    if (!$target.hasClass('wishlist-added')) {
      $target
        .addClass('wishlist-added')
        .find('.text')
        .text(window.wishlist.added);

      if (wishlistContainer.length > 0) {
        halo.setProductForWishlistPage(handle);
      }

      wishlistList.push(handle);
      localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
    } else {
      $target
        .removeClass('wishlist-added')
        .find('.text')
        .text(window.wishlist.add);

      if (wishlistContainer.length > 0) {
        if ($('[data-wishlist-added="wishlist-' + id + '"]').length > 0) {
          $('[data-wishlist-added="wishlist-' + id + '"]').remove();
        }
      }

      wishlistList.splice(index, 1);
      localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
      halo.wishlistPagination();

      if (wishlistContainer.length > 0) {
        wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

        if (wishlistList.length > 0) {
          halo.updateShareWishlistViaMail();
        } else {
          $('[data-wishlist-container]')
            .addClass('is-empty')
            .html(`\
              <div class="wishlist-content-empty text-center">\
                <span class="wishlist-content-text">${window.wishlist.empty}</span>\
                <div class="wishlist-content-actions">\
                  <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
                    ${window.wishlist.continue_shopping}\
                  </a>\
                </div>\
              </div>\
            `);

          $('[data-wishlist-footer]').hide();
        }
      }
    }
    $('[data-wishlist-count]').text(wishlistList.length);
    halo.setProductForWishlist(handle);
  }
});

document.addEventListener("click", async function (e) {
  const btn = e.target.closest('product-form button[type="submit"]');
  if (!btn) return;

  const checkbox = document.getElementById("gift-addon-checkbox");
  const giftBox = document.querySelector(".gift-addon-box");

  if (!checkbox || !giftBox || !checkbox.checked) return;

  const giftVariantId = Number(giftBox.dataset.giftVariantId);

  // Main product add hone ke baad Gift Bag add karo
  setTimeout(async () => {
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: giftVariantId,
          quantity: 1
        })
      });

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (err) {
      console.error("Gift Bag Error:", err);
    }
  }, 700);
});

document.addEventListener("DOMContentLoaded", async () => {
  const giftBox = document.querySelector(".gift-addon-box");
  const checkbox = document.getElementById("gift-addon-checkbox");

  if (!giftBox || !checkbox) return;

  const giftVariantId = Number(giftBox.dataset.giftVariantId);

  try {
    // Cart load karke check karega ki Gift Bag pehle se add hai ya nahi
    const cart = await fetch("/cart.js").then((res) => res.json());

    const giftItem = cart.items.find(
      (item) => item.variant_id === giftVariantId
    );

    if (giftItem) {
      checkbox.checked = true;
    }

    checkbox.addEventListener("change", async () => {
      try {
        if (checkbox.checked) {
          // Gift Bag add
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: giftVariantId,
              quantity: 1,
            }),
          });
        } else {
          // Gift Bag remove
          const latestCart = await fetch("/cart.js").then((res) => res.json());

          const existingGift = latestCart.items.find(
            (item) => item.variant_id === giftVariantId
          );

          if (existingGift) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: existingGift.key,
                quantity: 0,
              }),
            });
          }
        }

        // Cart refresh
        window.location.reload();
      } catch (error) {
        console.error("Gift Bag Error:", error);
      }
    });
  } catch (error) {
    console.error("Cart Error:", error);
  }
});

/* ============================================================
   TABBY WIDGET — BACKGROUND REMOVE + LOGO STYLE
   ============================================================ */
(() => {
  const cleanTabby = () => {
    // 1) Tabby ke common containers dhundo (background white wrapper)
    const tabbyContainers = document.querySelectorAll(
      '.tabby_promo, [class*="SnippetWrapper"], [class*="SnippetDefault"], [data-test="promo-widget-snippet-text-container"]'
    );

    tabbyContainers.forEach((el) => {
      el.style.setProperty("background", "transparent", "important");
      el.style.setProperty("background-color", "transparent", "important");
      el.style.setProperty("box-shadow", "none", "important");
      el.style.setProperty("border", "none", "important");
      el.style.setProperty("border-radius", "0", "important");
    });

    // 2) Sabhi spans inside tabby widget block + spacing
    document.querySelectorAll(".tabby_promo span").forEach((span) => {
      span.style.setProperty("display", "block", "important");
      span.style.setProperty("margin-bottom", "10px", "important");
    });

    // 3) SVG background remove karo (widget root ke andar)
    document.querySelectorAll('.tabby_promo svg, [data-test="promo-widget-snippet-text-container"] svg').forEach((svg) => {
      svg.style.setProperty("background", "transparent", "important");
      svg.style.setProperty("background-color", "transparent", "important");
    });

    // 4) Green background path => transparent (agar SVG/shadow DOM me hai)
    const findAndClearGreenPath = (node) => {
      // Shadow DOM me check
      if (node.shadowRoot) {
        const greenPath = node.shadowRoot.querySelector('svg path[fill="#6CFF93"]');
        if (greenPath) {
          greenPath.setAttribute("fill", "transparent");
        }
        node.shadowRoot.querySelectorAll("*").forEach(findAndClearGreenPath);
      }
      // Normal DOM children
      if (node.children) {
        Array.from(node.children).forEach(findAndClearGreenPath);
      }
    };

    document.querySelectorAll(".tabby_promo").forEach(findAndClearGreenPath);
  };

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanTabby);
  } else {
    cleanTabby();
  }

  // Observer — sirf Tabby ke liye, body par nahi (performance ke liye)
  const observer = new MutationObserver(() => {
    cleanTabby();
  });

  const startObserver = () => {
    const tabbyRoots = document.querySelectorAll(".tabby_promo");
    if (tabbyRoots.length) {
      tabbyRoots.forEach((root) => {
        observer.observe(root, { childList: true, subtree: true });
      });
    } else {
      // agar .tabby_promo abhi tak load nahi hua to body observe karo
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserver);
  } else {
    startObserver();
  }
})();

/* ============================================================
   URL PARAM CLEANUP
   ============================================================ */
(function () {
  const paramsToRemove = ["_pos", "_sid", "_ss"];

  function cleanProductUrl() {
    const url = new URL(window.location.href);

    // Sirf product pages par run hoga
    if (!url.pathname.startsWith("/products/")) return;

    let changed = false;

    paramsToRemove.forEach((param) => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        changed = true;
      }
    });

    // Page reload kiye bina URL clean karega
    if (changed) {
      const cleanUrl = url.pathname + url.search + url.hash;
      window.history.replaceState(window.history.state, "", cleanUrl);
    }
  }

  cleanProductUrl();
})();

/* ============================================================
   GIFT MESSAGE MAX LENGTH
   ============================================================ */
(function () {
  const setMaxLength = () => {
    const messageBox = document.querySelector('.gbbGiftMessageV2InputField');
    if (messageBox) {
      messageBox.setAttribute('maxlength', '120');
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setMaxLength);
  } else {
    setMaxLength();
  }

  // Agar dynamic load ho to bhi pakad lo
  setTimeout(setMaxLength, 1500);
})();




